module.exports = __webpack_public_path__ + "static/media/document.8613269e.png";